import Game from '../Game';
import AnimationSystem from '../System/Animation/AnimationSystem';
import RenderSystem from '../System/Render/RenderSystem';
import TransitionSystem from '../System/TransitionSystem';
import Scene from './Scene';

export default class TransitionScene extends Scene {
    public init(): void {
        this.addSystem(new TransitionSystem(Game.state));
        this.addSystem(new AnimationSystem(Game.state));
        this.addSystem(new RenderSystem(Game.state));

        this.systems.forEach(system => system.init());
    }
}
